// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://anuplnumlnnftevswmxs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFudXBsbnVtbG5uZnRldnN3bXhzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUxMjk1ODgsImV4cCI6MjA2MDcwNTU4OH0.CIbqVHkKfDAxn-2qxaTSPowE3i4q4ZGoYcfFMbfX7xA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);